/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type TierType = "CORE" | "ENTERPRISE" | "FREE_FOREVER" | "LITE" | "PRO" | "TRIAL" | "%future added value";
export type BudgetData_company = {
    readonly tier: TierType | null;
    readonly " $fragmentRefs": FragmentRefs<"HighLevelBudgetNumbers_company">;
    readonly " $refType": "BudgetData_company";
};
export type BudgetData_company$data = BudgetData_company;
export type BudgetData_company$key = {
    readonly " $data"?: BudgetData_company$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"BudgetData_company">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BudgetData_company",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tier",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HighLevelBudgetNumbers_company"
    }
  ],
  "type": "Company"
};
(node as any).hash = '8eb87cf1eb410c763f34620fbc3e621a';
export default node;
